import { useEffect, useState } from 'react'
import { usePermission } from '@fs/zion-permissions'
import { useQueryParams } from '@fs/zion-router'

const lightyearImageAuditPermissions = ['RMSGroupWritePermission', 'RMSArtifactWritePermission']

export default function useDetermineMode() {
  const {
    query: { mode },
  } = useQueryParams()
  const [hasLightyearRecordMetadataReviewPermission, lightyearRecordMetadataReviewCheckStatus] = usePermission(
    'LightyearRecordMetadataReviewPermission',
    'LightyearContext'
  )

  const [hasLightyearRecordsHomePermission, lightyearRecordsHomeCheckStatus] = usePermission(
    'LightyearRecordsHomePermission',
    'LightyearContext'
  )

  const [hasLightyearImageAuditPermission, lightyearImageAuditCheckStatus] = usePermission(
    lightyearImageAuditPermissions,
    'RMSContext'
  )

  const [showRecordMetadataReview, setShowRecordMetadataReview] = useState()
  useEffect(() => {
    if (lightyearRecordMetadataReviewCheckStatus === 'loaded' && typeof setShowRecordMetadataReview === 'function') {
      setShowRecordMetadataReview(hasLightyearRecordMetadataReviewPermission && mode === 'review')
    }
  }, [
    hasLightyearRecordMetadataReviewPermission,
    lightyearRecordMetadataReviewCheckStatus,
    mode,
    setShowRecordMetadataReview,
  ])

  const [showMetadataAudit, setShowMetadataAudit] = useState()
  useEffect(() => {
    if (
      lightyearImageAuditCheckStatus === 'loaded' &&
      lightyearRecordsHomeCheckStatus === 'loaded' &&
      typeof setShowMetadataAudit === 'function'
    ) {
      setShowMetadataAudit(
        hasLightyearImageAuditPermission && hasLightyearRecordsHomePermission && mode === 'metadataAudit'
      )
    }
  }, [
    hasLightyearRecordMetadataReviewPermission,
    lightyearRecordMetadataReviewCheckStatus,
    mode,
    setShowMetadataAudit,
    hasLightyearImageAuditPermission,
    lightyearImageAuditCheckStatus,
    hasLightyearRecordsHomePermission,
    lightyearRecordsHomeCheckStatus,
  ])

  const [showImageQualityAudit, setShowImageQualityAudit] = useState()
  useEffect(() => {
    if (typeof setShowImageQualityAudit === 'function') {
      setShowImageQualityAudit(mode === 'imageQualityAudit')
    }
  }, [mode, setShowImageQualityAudit])

  return { showRecordMetadataReview, showMetadataAudit, showImageQualityAudit }
}
